import { gql } from '@apollo/client';

export type FeedbackItems = {
  resources: {
    application: {
      feedback: Feedback[];
    };
  };
};

export type Feedback = {
  applicationId: number;
  message?: string;
  login?: string;
  rating: number;
  timestamp: string;
  url: string;
};

/**
 * Get the application feedback data
 * @param applicationId
 */
export const GetApplicationFeedbackQuery = gql`
  query Feedback($applicationId: Int!) {
    resources {
      application(applicationId: $applicationId) {
        feedback {
          message
          rating
          timestamp
          url
          login
        }
      }
    }
  }
`;
